module.exports = __webpack_public_path__ + "media/about/banner-prop-f3366f9b.png";